<template>
  <div class="we-chat-mini" :class="{ 'dropdown-open': state.orgDropdownOpen }">
    <van-pull-refresh v-model="state.loading" :disabled="state.orgDropdownOpen" @refresh="onRefresh">
    <div class="swipe-content">
      <van-swipe
        class="my-swipe"
        :autoplay="3000"
        indicator-color="white"
        style="height: 200px"
        lazy-render
      >
        <van-swipe-item v-for="image in images" :key="image">
          <van-image fit="cover" :src="image" />
        </van-swipe-item>
      </van-swipe>
    </div>
    <div
      class="org-content"
      v-if="state.isLogin"
      :style="{
        'padding-top': state.permissionType == 1 ? '0px' : '6px',
        'padding-bottom': state.permissionType == 1 ? '0px' : '6px'
      }"
    >
      <van-dropdown-menu
        v-if="state.permissionType == 1"
        @click-overlay="onDropdownOverlayClick"
      >
        <van-dropdown-item
          ref="orgDropdownItemRef"
          @change="handleOrgChange"
          @open="onDropdownOpen"
          @closed="onDropdownClosed"
          v-model="state.currentOrg"
          :options="state.orgList"
        />
      </van-dropdown-menu>

      <van-checkbox v-if="state.permissionType == 1" @click="handleOnlyIndividuals" style="margin-left: 24px" v-model="state.onlyIndividuals">仅看个人数据</van-checkbox>
      
      <van-icon style="position: absolute;right: 12px;" size="20" @click="onRefresh" name="replay" />
    </div>
    
    <div class="content-row">
      <div class="content-title" @click="handleGoDetail(1)">
          书院经营数据
          <van-icon v-if="state.permissionType == 1" name="arrow" />
      </div>
      <div class="report-content">
        <div class="report-total-container">
          <div class="report-total" @click="handleYongClick(ModuleType.College)">
            <span class="title-label">签约学生</span>
            <span v-if="state.isLogin" class="title-value">{{
              state.overview.stuNo ?? 0
            }}</span>
            <span v-else class="title-value">--</span>
          </div>
          <div
            class="report-total"
            @click="handleYongClick(ModuleType.InCourtyard)"
          >
            <span class="title-label">入住学生</span>
            <span
              v-if="state.isLogin"
              class="title-value"
              style="color: #91cc75"
              >{{ state.overview.checkInNo ?? 0 }}</span
            >
            <span v-else class="title-value" style="color: #91cc75">--</span>
          </div>

          <div class="report-total" @click="handleYongClick(ModuleType.Due)">
            <span class="title-label">即将到期</span>
            <span v-if="state.isLogin" class="title-value" style="color: red">{{
              state.overview.stuEndNo ?? 0
            }}</span>
            <span v-else class="title-value" style="color: red">--</span>
          </div>
        </div>
        
        <!-- 书院学生子分类 -->
        <div class="college-breakdown">
          <div class="breakdown-item">
            <div class="breakdown-indicator active-indicator"></div>
            <span class="breakdown-label">已生效</span>
            <span v-if="state.isLogin" class="breakdown-value active-value">{{
              state.overview.activeStudentNo ?? 0
            }}</span>
            <span v-else class="breakdown-value active-value">--</span>
          </div>
          <div class="breakdown-item">
            <div class="breakdown-indicator pending-indicator"></div>
            <span class="breakdown-label">待生效</span>
            <span v-if="state.isLogin" class="breakdown-value pending-value">{{
              state.overview.inactiveStudentNo ?? 0
            }}</span>
            <span v-else class="breakdown-value pending-value">--</span>
          </div>
        </div>
      </div>
    </div>
    

    <!-- 今日沟通与床位看板卡片布局 -->
    <div class="content-row two-cards" v-if="state.isLogin">
      <div class="two-cards-inner">
        <div class="card-item" @click="handleGoCommunication">
          <div class="communication-icon">
            <van-icon name="chat-o" size="20" />
          </div>
          <span class="card-text">今日沟通  {{state.overview.todayCommunication ?? 0}}</span>
          <van-icon name="arrow" size="16" />
        </div>
        <div class="card-item" @click="handleGoBedBoard">
          <div class="bed-icon">
            <van-icon name="hotel-o" size="20" />
          </div>
          <span class="card-text">床位看板</span>
          <van-icon name="arrow" size="16" />
        </div>
      </div>
    </div>

    <div class="content-row" v-for="(item, index) in state.statistics" :key="index">
      <div class="content-title" @click="handleGoDetail">
          {{ item.timeDesc }}
        </div>
      <div class="report-content">
        <div class="report-total-container">
          <div
            class="report-total"
            @click="handleChuClick(ModeType.ReturnHospital,item)"
          >
            <span v-if="state.isLogin" class="title-value"
              >{{ item.actualArrival ?? 0 }}/{{
                item.expectedArrival ?? 0
              }}</span
            >
            <span v-else class="title-value">--</span>
            <span class="title-label title-label-bottom">回院</span>
          </div>
          <div class="report-total" @click="handleChuClick(ModeType.Lunch,item)">
            <span v-if="state.isLogin" class="title-value"
              >{{ item.actualLunch ?? 0 }}/{{ item.expectedLunch ?? 0 }}</span
            >
            <span v-else class="title-value">--</span>
            <span class="title-label title-label-bottom" v-if="item.time === 2">午餐</span>
            <span class="title-label title-label-bottom" v-if="item.time === 3">晚餐</span>
          </div>

          <div class="report-total" @click="handleChuClick(ModeType.NoonBreak,item)" v-if="item.time === 2">
            <span v-if="state.isLogin" class="title-value"
              >{{ item.actualNap ?? 0 }}/{{ item.expectedNap ?? 0 }}</span
            >
            <span v-else class="title-value">--</span>
            <span class="title-label title-label-bottom">午休</span>
          </div>

          <div
            class="report-total"
            @click="handleChuClick(ModeType.LeavingHospital,item)"
          >
            <span v-if="state.isLogin" class="title-value"
              >{{ item.actualDeparture ?? 0 }}/{{
                item.expectedDeparture ?? 0
              }}</span
            >
            <span v-else class="title-value">--</span>
            <span class="title-label title-label-bottom">离院</span>
          </div>
        </div>
      </div>
    </div>
    <div class="login-container" v-if="state.isLogin">
        <!-- <van-cell title="退出登录" @click="handleGoLogin" is-link /> -->
        <van-button size="small" @click="handleGoLoginOut" plain type="primary" style="width: 120px">退出登录</van-button>
    </div>
    </van-pull-refresh>
  </div>
</template>
<script>
import { defineComponent, onMounted, reactive, ref } from "vue";
import { useRoute, useRouter } from "vue-router";

import EmptyData from "@/components/EmptyData.vue";
import HomeBackImg from "@/assets/home_back.jpg";
import HomeBackImg_1 from "@/assets/home_back_1.jpg";
import HomeBackImg_2 from "@/assets/home_back_2.jpg";

import { ModuleType, ModeType } from "@/utils/const";

import { queryGetDataForNoon, queryGetDataSummary, logOutSystem, querySelectOrgListByUser } from "@/api/user";
import dayjs from "dayjs";
import { showConfirmDialog, showNotify } from "vant";
import { showLoadingToast, closeToast } from 'vant';

export default defineComponent({
  components: {
    EmptyData,
  },
  setup() {
    const images = [HomeBackImg_1, HomeBackImg, HomeBackImg_2];
    const router = useRouter();
    const route = useRoute();

    const state = reactive({
      loading: false,
      isLogin: false,
      statistics: [
        {
          actualArrival: null,
          actualDeparture: null,
          actualLunch: null,
          actualNap: null,
          expectedArrival: null,
          expectedDeparture: null,
          expectedLunch: null,
          expectedNap: null,
          time: 2,
          timeDes: '中午段'
        },
      ],
      currentOrg: null,
      onlyIndividuals: 0,
      orgList: [],
      overview: {},
      permissionType: 2, // 2: 个人 1: 书院
      orgDropdownOpen: false
    });

    const orgDropdownItemRef = ref(null);

    onMounted(async () => {
      console.log("pathParams:", route?.query);
      if (route?.query?.page) {
        router.push({
          path: `${route?.query?.page}`,
          query: {
            id: route?.query?.id,
          },
        });
      } else if (route?.query?.token && route?.query?.userInfo) {
        localStorage.setItem('userInfo', route?.query?.userInfo);
        localStorage.setItem('token', route?.query?.token);
        state.permissionType = route?.query?.userInfo?.permissionType ?? 2
      }
      
      querySysOrgListByUser();
    });

    const onRefresh = () => {
      if (state.orgDropdownOpen && orgDropdownItemRef.value) {
        orgDropdownItemRef.value.toggle(false)
      }
      refreshData()
    }

    const onDropdownOpen = () => {
      state.orgDropdownOpen = true
    }

    const onDropdownClosed = () => {
      state.orgDropdownOpen = false
    }

    const onDropdownOverlayClick = () => {
      state.orgDropdownOpen = false
    }

    const refreshData = async () => {
      console.log('开始')
      state.loading = true
      const toast = showLoadingToast({
        message: '数据刷新中...',
        forbidClick: true,
        loadingType: 'spinner',
        duration: 0,
      });
      const result = await Promise.all([queryGetDataForNoonData(), queryGetDataSummaryData()])
      console.log(result)
      state.loading = false
      console.log('完成')
      closeToast();
    }

    const handleOrgChange = (value) => {
      console.log('value>>>>>>>', value);
      state.currentOrg = value
      localStorage.setItem('currentOrg', state.currentOrg)
      queryGetDataForNoonData();
      queryGetDataSummaryData();
    }

    const querySysOrgListByUser = async () => {
      state.orgList = [];
      try {
        const userInfo = JSON.parse(localStorage.getItem('userInfo') ?? '{}');
        console.log('userInfo>>>>>>',userInfo)
        const result = await querySelectOrgListByUser({
          id: userInfo?.id,
        });
        console.log("result:", result);
        if (result.code === "00") {
          state.orgList = (result.data.map(item => {
            return {
              ...item,
              text: item.name,
              value: item.id
            }
          }) ?? []).filter(item => item.id != 1 && item.id != 2);
          let currentOrg = localStorage.getItem('currentOrg')
          if(currentOrg && !state.orgList.find(item => item.id == currentOrg)) {
            localStorage.removeItem('currentOrg')
            currentOrg = null
          }

          if(currentOrg) {
            state.currentOrg = Number(currentOrg || state.orgList?.[0].value)
            state.onlyIndividuals = Number(localStorage.getItem('onlyIndividuals') || 0)
          } else {
            state.currentOrg = state.orgList?.[0].value
            localStorage.setItem('currentOrg', state.currentOrg)
            
          }

          queryGetDataForNoonData();
          queryGetDataSummaryData();
          
        }
      } catch (error) {
        state.orgList = []
        console.log('error:>>>', error)
      }
    }


    const queryGetDataSummaryData = async () => {
      console.log(localStorage.getItem("userInfo"))

      const _user = localStorage.getItem("userInfo");
      const userInfo = JSON.parse(_user ?? "{}");
      
      if (!localStorage.getItem("token") || !_user) {
        state.isLogin = false;
        localStorage.removeItem("userInfo");
        localStorage.removeItem("token");
        localStorage.removeItem("statistics");
        localStorage.removeItem("currentOrg");
        localStorage.removeItem("onlyIndividuals");
        return;
      }

      state.permissionType = userInfo?.permissionType ?? 2
      try {
        const result = await queryGetDataSummary({
          permissionOrg: state.currentOrg,
          oneSelf: state.onlyIndividuals ? 1 : 0
        });
        console.log("result:", result);
        if (result.code === "00") {
          state.overview = result.data ?? {};
          state.isLogin = true;
        } else if (result.code === "02") {
          state.isLogin = false;
        } else {
        }
      } catch (error) {
        console.log("error:>>>", error);
      }
    };

    const queryGetDataForNoonData = async () => {
      if (!localStorage.getItem("token") || !localStorage.getItem("userInfo")) {
        state.isLogin = false;
        localStorage.removeItem("userInfo");
        localStorage.removeItem("token");
        localStorage.removeItem("statistics");
        localStorage.removeItem("currentOrg");
        localStorage.removeItem("onlyIndividuals");
        return;
      }
      if(localStorage.getItem('statistics')) {
        state.statistics = JSON.parse(localStorage.getItem('statistics'))
      }

      try {
        const result = await queryGetDataForNoon({
          day: dayjs().format("YYYY-MM-DD"),
          permissionOrg: state.currentOrg,
          oneSelf: state.onlyIndividuals ? 1 : 0
        });
        console.log("result:", result);
        if (result.code === "00") {
          state.statistics = result.data ?? [
            {
              actualArrival: null,
              actualDeparture: null,
              actualLunch: null,
              actualNap: null,
              expectedArrival: null,
              expectedDeparture: null,
              expectedLunch: null,
              expectedNap: null,
              time: 2,
              timeDes: '中午段'
            },
          ];
          localStorage.setItem('statistics', JSON.stringify(state.statistics))
          state.isLogin = true;
        } else if (result.code === "02") {
          state.isLogin = false;
        } else {
        }
      } catch (error) {
        console.log("error:>>>", error);
      }
    };

    const handleGoLogin = () => {
      // if (window.__wxjs_environment === 'miniprogram') {
      //   window.wx.miniProgram.navigateTo({
      //     url: '/pages/loginPhone/loginPhone'
      //   })
      // } else {
      //   router.push('/login');
      // }
      // router.push('/login');
      window.wx.miniProgram.navigateTo({
        url: '/pages/loginPhone/loginPhone'
      })
    };

    const handleGoLoginOut = () => {
      showConfirmDialog({
        title: "温馨提示",
        message: "您确定要退出登录吗？",
      })
        .then(async () => {
          // on confirm
          const _user = localStorage.getItem("userInfo");
          const userInfo = JSON.parse(_user ?? "{}");
          const result = await logOutSystem({
            id: userInfo.id
          })
          if(result.code === '00') {
            localStorage.removeItem("userInfo");
            localStorage.removeItem("token");
            localStorage.removeItem("statistics");
            localStorage.removeItem("currentOrg");
            localStorage.removeItem("onlyIndividuals");
            
            showNotify({ type: 'success', message: '退出登录成功' , duration: 2000 })
            state.isLogin = false;
          } else {
            showNotify({ type: 'warning', message: result.message, duration: 2000 })
          }
          
        })
        .catch((e) => {
          // on cancel
          console.log("取消登录",e);
        });
    }

    const handleYongClick = (moduleType) => {
      if (!isLoginDialog()) {
        return;
      }
      router.push({
        path: "/collegeStudents",
        query: {
          moduleType,
          oneSelf: state.onlyIndividuals ? 1 : 0,
          permissionOrg: state.currentOrg
        },
      });
    };

    const handleChuClick = (moduleType,item) => {
      if (!isLoginDialog()) {
        return;
      }
      router.push({
        path: "/monitorStudents",
        query: {
          moduleType,
          timeType: item.time,
          oneSelf: state.onlyIndividuals ? 1 : 0,
          permissionOrg: state.currentOrg
        },
      });
    };

    const isLoginDialog = () => {
      if (state.isLogin) {
        return true;
      }
      showConfirmDialog({
        title: "温馨提示",
        message: "当前操作需要登录，请前往登录。",
      })
        .then(() => {
          // on confirm
          console.log("确认登录");
          handleGoLogin();
        })
        .catch(() => {
          // on cancel
          console.log("取消登录");
        });
    };

    const handleGoDetail = (type) => {
      if (!isLoginDialog()) {
        return;
      }  

      if(type === 1 && state.permissionType === 2) {
        return;
      }

      router.push({
        path: "/managementPanel",
        query: {
          currentOrg: state.currentOrg
        },
      });
    }

    const handleOnlyIndividuals = (value) => {      
      localStorage.setItem('onlyIndividuals',state.onlyIndividuals ? 1 : 0)
      queryGetDataForNoonData();
      queryGetDataSummaryData();
    }

    const handleGoCommunication = () => {
      if (!isLoginDialog()) {
        return;
      }
      router.push({
        path: "/communicationRecords",
        query: {
          oneSelf: state.onlyIndividuals ? 1 : 0,
          permissionOrg: state.currentOrg
        },
      });
    }

    const handleGoBedBoard = () => {
      if (!isLoginDialog()) {
        return;
      }
      try { sessionStorage.setItem('bedBoardEntry', 'console'); } catch (e) {}
      router.push({
        path: "/bedBoard",
        query: {
          currentOrg: state.currentOrg
        },
      });
    }

    return {
      state,
      handleGoLogin,
      images,
      handleYongClick,
      ModuleType,
      handleChuClick,
      ModeType,
      handleGoLoginOut,
      handleOrgChange,
      handleGoDetail,
      handleOnlyIndividuals,
      onRefresh,
      handleGoCommunication,
      handleGoBedBoard,
      onDropdownOpen,
      onDropdownClosed,
      onDropdownOverlayClick,
      orgDropdownItemRef
    };
  },
});
</script>

<style lang="scss" scoped>
.my-swipe .van-swipe-item {
  color: #fff;
  font-size: 20px;
  line-height: 200px;
  text-align: center;
}

.we-chat-mini {
  background: #e9f1f8;
  height: 100vh;
  width: 100%;
  overflow-y: scroll;
  padding-bottom: 22px;
  z-index: 100;
  margin-top: 4px;
  position: relative;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
}

.swipe-content {
  margin-left: 6px;
  margin-right: 6px;
}

.org-content {
  margin: 6px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  position: relative;
}

.we-chat-mini.dropdown-open {
  overflow: hidden !important;
  height: 100vh;
}

.report-content {
  /* margin: 12px 6px; */
  /* padding-top: 14px; */
  /* width: calc(100% - 12px); */
  background-color: #fff;
  border-radius: 7px;
  display: flex;
  flex-direction: column;
  padding: 16px 0;
}

.content-row {
  background-color: #fff;
  border-radius: 7px;
  width: calc(100% - 12px);
  margin: 12px 6px;
  padding-top: 4px;
}

.report-total-container {
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 100%;
  margin-bottom: 16px;
}

.report-total {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
}

/* 书院学生子分类样式 */
.college-breakdown {
  display: flex;
  justify-content: center;
  gap: 40px;
  padding: 16px 20px;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  margin: 0 12px;
  border-radius: 8px;
  border: 1px solid #e9ecef;
  position: relative;
}

.college-breakdown::before {
  content: '';
  position: absolute;
  top: -8px;
  left: 14%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-bottom: 8px solid #e9ecef;
}

.breakdown-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 20px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.breakdown-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  background: rgba(255, 255, 255, 0.95);
}

.breakdown-indicator {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}

.active-indicator {
  background: linear-gradient(135deg, #52c41a 0%, #73d13d 100%);
  box-shadow: 0 0 8px rgba(82, 196, 26, 0.3);
}

.pending-indicator {
  background: linear-gradient(135deg, #faad14 0%, #ffc53d 100%);
  box-shadow: 0 0 8px rgba(250, 173, 20, 0.3);
}

.breakdown-label {
  font-family: PingFang SC;
  font-weight: 500;
  font-size: 14px;
  color: #333333;
  white-space: nowrap;
}

.breakdown-value {
  font-family: PingFang SC;
  font-weight: 600;
  font-size: 16px;
  margin-left: 4px;
}

.active-value {
  color: #52c41a;
}

.pending-value {
  color: #faad14;
}

.title-label {
  font-family: PingFang SC;
  font-weight: 400;
  font-size: 17px;
  color: #000000;
}

.title-value {
  font-family: PingFang SC;
  font-weight: 400;
  font-size: 20px;
  color: #fac858;
  margin-top: 12px;
}

.title-label-bottom {
  margin-top: 12px;
}

.login-container {
  text-align: center;
  width: 100vw;
  bottom: 40px;
  margin-top: 22px;
}

.content-title {
  text-align: left;
    margin-left: 12px;
    margin-top: 12px;
    margin-right: 12px;
    width: calc(100% - 24px);
    display: flex;
    align-items: center;
    font-weight: bold;
    justify-content: space-between;
    cursor: pointer;
    transition: all 0.2s;
}

.content-title:hover {
  opacity: 0.7;
}

:deep(.van-dropdown-menu__bar) {
  background: none !important;
  box-shadow: none !important;
}

.communication-entry {
  background: #fff;
  border: 1px solid #e8f1f8;
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.1);
  // margin-top: 18px;
  position: relative;
  overflow: hidden;
}

.communication-entry::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  width: 4px;
  height: 100%;
  background: linear-gradient(180deg, #667eea 0%, #764ba2 100%);
}

.communication-title {
  color: #333 !important;
  padding: 0 0 16px 0;
}

.communication-icon {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 50%;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  color: #fff;
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.25);
}

.communication-title span {
  color: #333;
  font-weight: 600;
}

.communication-title :deep(.van-icon) {
  color: #969799;
}

/* 双卡片布局样式 */
.two-cards {
  padding: 10px 10px 14px 10px;
  width: calc(100% - 36px);
}

.two-cards-inner {
  display: flex;
  gap: 12px;
}

.card-item {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  border: 1px solid #e8f1f8;
  border-radius: 8px;
  padding: 10px 12px;
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.1);
  cursor: pointer;
  transition: all 0.2s;
}

.card-item:hover {
  opacity: 0.85;
}

.card-text {
  flex: 1;
  margin: 0 8px;
  color: #333;
  font-weight: 600;
}

.bed-icon {
  background: linear-gradient(135deg, #13c2c2 0%, #36cfc9 100%);
  border-radius: 50%;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  color: #fff;
  box-shadow: 0 2px 8px rgba(19, 194, 194, 0.25);
}
</style>
